//import Message from "../../models/Message";
import axios from "axios";
import { API_BASE_URL, FETCH_LIMIT } from "../../globalVars";

export default {
  namespaced: true,

  actions: {
    async hydrate({ commit }, lastUpdateTime = null) {
      const store = this;
      const last = this.getters["entities/settings/query"]().first()
        .lastUpdateFromServer;
      await fetchNext({
        store: store,
        offset: 0,
        lastDateTime: lastUpdateTime ? lastUpdateTime : last
      });
    },

    async clickCall(context, { call, action, actionDate }) {
      let store = this;
      const accountId = store.state.entities.settings.data[1].accountId;
      const userId = store.state.entities.settings.data[1].userId;
      const phoneNumber = call.isInbound ? call.fromPhone : call.toPhone;
      let updateCustomer = {
        id: call.customerId,
        accountId: accountId,
        isDirty: true,
        isRead: true // to ensure update of viewedAt
      };
      let callData = {
        id: call.id,
        accountId: accountId,
        isDirty: true,
        phoneNumber: phoneNumber
      };
      if (action == "call_archive") {
        actionDate = new Date();
        updateCustomer.callsArchivedAt = actionDate;
        updateCustomer.callsSnoozedUntil = null;
        await store.dispatch("entities/calls/update", {
          where: tempCall => {
            return tempCall.id === call.id;
          },
          data: { isArchived: true, isSnoozed: false }
        });
      } else if (action == "call_unarchive") {
        actionDate = null;
        updateCustomer.callsArchivedAt = actionDate;
        await store.dispatch("entities/calls/update", {
          where: tempCall => {
            return tempCall.id === call.id;
          },
          data: { isArchived: false }
        });
      }

      if (
        call.customerId &&
        !["call_archive", "call_unarchive", "call_snooze"].includes(action)
      ) {
        store.dispatch("entities/customers/fetchCustomerDataJoins", {
          joins:
            null,
          customerId: call.customerId,
          startFresh: true
        });
        store.dispatch("entities/users/update", {
          where: userId,
          data: { currentCustomerId: call.customerId }
        });
        store.dispatch("entities/customerLookups/update", {
          where: call.customerId,
          data: { viewedAt: Date.now() }
        });
      }
      store.dispatch("entities/calls/update", {
        where: tempCall => {
          const isMatch =
            (tempCall.isInbound ? tempCall.fromPhone : tempCall.toPhone) ==
            phoneNumber;
          return isMatch;
        },
        data: { isUnread: false }
      });
      if (call.customerId) {
        store.dispatch("entities/customers/updateCustomer", updateCustomer);
      } else {
        let userId = store.state.entities.settings.data[1].userId;
        store.dispatch("entities/users/update", {
          where: userId,
          data: {
            currentCustomerId: null
          }
        });
        store.dispatch("entities/calls/updateCall", {
          where: tempCall => {
            return tempCall.id === call.id;
          },
          data: callData
        });
      }
      store.dispatch("entities/accounts/pingAccountLevelDisplay");
    },

    async updateCall(context, call) {
      if (call.data && call.data.isDirty === true) {
        const store = this;
        try {
          axios({
            method: "patch",
            url: API_BASE_URL + `/call/${call.data.id}`,
            data: call.data,
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`
            }
          });
          await store.dispatch("entities/settings/setIsOffline", false);
        } catch (error) {
          await store.dispatch("entities/settings/setIsOffline", true);
        }
      }
    },

    async updateCallRecordingUrl(context, callId, externalId, path) {
      let response = await axios({
        method: "get",
        url:
          API_BASE_URL +
          `/account?do=file-url&externalId=${externalId}&path=${path}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`
        }
      });
      const url = response ? response.url : null;
      const store = this;
      store.dispatch("entities/calls/update", {
        where: callId,
        data: {
          recordingUrl: url
        }
      });
      store.dispatch("entities/settings/setIsOffline", false);
    }
  }
};

async function fetchNext({ store, offset, lastDateTime = 0 }) {
  try {
    let response = await axios({
      method: "get",
      url: API_BASE_URL + `/call?$limit=${FETCH_LIMIT}&$skip=${offset}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`
      }
    });
    const obj = response.data.data;
    const maxRows = response.data.total;
    let calls = [];
    obj.forEach(function(call) {
      calls.push({
        isDirty: false,
        id: call.id,
        childId: call.childId,
        fromPhone: call.fromPhone,
        toPhone: call.toPhone,
        isInbound: call.isInbound,
        startTime: call.startTime,
        durationSeconds: call.durationSeconds,
        recordingUploadComplete: call.recordingUploadComplete,
        recordingExternalId: call.recordingExternalId,
        recordingDurationSeconds: call.recordingDurationSeconds,
        recordingType: call.recordingType,
        transcription: call.transcription,
        customerId: call.customerId,
        contactInfoId: call.contactInfoId,
        employeeId: call.employeeId,
        accountPhoneNumberId: call.accountPhoneNumberId,
        createdAt: Date.parse(call.createdAt),
        viewedAt: Date.parse(call.viewedAt),
        isUnread: call.isUnread
      });
    });
    if (calls.length > 0) {
      store.dispatch("entities/calls/insertOrUpdate", {
        data: calls
      });
    }
    store.dispatch("entities/settings/setIsOffline", false);
    if (maxRows > FETCH_LIMIT + offset) {
      await fetchNext({
        store,
        offset: FETCH_LIMIT + offset,
        lastDateTime
      });
    }
  } catch (error) {
    store.dispatch("entities/settings/setIsOffline", true);
  }
}
